/* =================================================================

  ドロワーメニュー

================================================================= */

export const drawer = function () {
  const elem = document.querySelector(".js-drawer");
  elem.addEventListener("click", function (e) {
    const isExpanded = e.currentTarget.getAttribute("aria-expanded") !== "false";
    e.currentTarget.setAttribute("aria-expanded", !isExpanded);

    document.documentElement.classList.toggle(`is-drawerActive`);

    //　ハンバーガーボタンの　Menu　のテキストを書き換え
    const output = document.querySelector(".js-hamburgerText");
    if (document.documentElement.classList.contains("is-drawerActive") == true) {
      output.innerHTML = "閉じる";
    } else {
      output.innerHTML = "Menu";
    }
  });

  const overlay = document.querySelector(".js-drawer-overlay");
  overlay.addEventListener("click", function () {
    document.documentElement.classList.remove(`is-drawerActive`);
    if (elem.getAttribute("aria-expanded") === "true") {
      elem.setAttribute("aria-expanded", "false");
    }
  });

  // ドロワーを閉じる共通処理
  const closeDrawer = () => {
    document.documentElement.classList.remove(`is-drawerActive`);
    elem.setAttribute("aria-expanded", false);
    const output = document.querySelector(".js-hamburgerText");
    if (output) output.innerHTML = "Menu";
  };

  // ドロワー内の全リンク
  const nav = document.querySelectorAll("#drawer a");
  for (let i = 0; i < nav.length; i++) {
    nav[i].addEventListener("click", function (e) {
      // "#" で始まる従来のアンカー
      if (this.getAttribute("href").startsWith("#")) {
        closeDrawer();
        return;
      }

      // フルパス（/about/#message 等）で「今と同じページ＋ハッシュあり」の場合だけ閉じる
      const url = new URL(this.href, location.href);
      const isSamePageAnchor = url.pathname === location.pathname && url.hash;
      if (isSamePageAnchor) {
        closeDrawer();
      }
    });
  }
};
